function NotFound404() {
    return (
      <div className="">
        404 Página no encontrada
      </div>
    );
  }
  
export default NotFound404;